import React, { useEffect, useState } from 'react';
import {
  dismissIsolationFailureBanner,
  getIsolationFailureBanner,
  subscribeIsolationFailureBanner,
} from '../utils/proxyFetchFailedUI';

/**
 * Persistent guidance when a renderer cannot reach this computer (AP/client isolation).
 * Ephemeral toasts are suppressed for this case — see proxyFetchFailedUI.
 */
export default function ProxyIsolationBanner() {
  const [banner, setBanner] = useState(() => getIsolationFailureBanner());

  useEffect(() => subscribeIsolationFailureBanner(() => {
    setBanner(getIsolationFailureBanner());
  }), []);

  if (!banner?.visible) return null;

  return (
    <div
      role="alert"
      style={{
        position: 'fixed',
        left: '50%',
        transform: 'translateX(-50%)',
        bottom: 96,
        zIndex: 10050,
        maxWidth: 'min(560px, calc(100vw - 32px))',
        borderRadius: 12,
        border: '1px solid rgba(245, 158, 11, 0.35)',
        background: 'rgba(20, 20, 32, 0.96)',
        boxShadow: '0 8px 32px rgba(0,0,0,0.35)',
        padding: '14px 16px 14px 18px',
        fontSize: 13,
        lineHeight: 1.5,
        color: 'var(--text-secondary, #ccc)',
      }}
    >
      <div style={{ display: 'flex', gap: 12, alignItems: 'flex-start' }}>
        <div style={{ flex: 1 }}>
          <div style={{ fontWeight: 600, color: 'var(--text-primary, #fff)', marginBottom: 4 }}>
            Network playback blocked
          </div>
          <div>{banner.message}</div>
        </div>
        <button
          type="button"
          aria-label="Dismiss"
          onClick={() => dismissIsolationFailureBanner()}
          style={{
            border: 'none',
            background: 'transparent',
            color: 'var(--text-tertiary, #888)',
            cursor: 'pointer',
            fontSize: 20,
            lineHeight: 1,
            padding: '0 4px',
            flexShrink: 0,
          }}
        >
          ×
        </button>
      </div>
    </div>
  );
}
